import React, { useState, useEffect } from 'react';
import { FaWhatsapp, FaArrowLeft, FaMap, FaTractor } from 'react-icons/fa';
import '../styles/blogArticle.css';

const openWhatsApp = (msg) =>
  window.open(`https://wa.me/5519995910565?text=${encodeURIComponent(msg)}`, '_blank');

/* ── CSS apenas para elementos exclusivos do DynaMap ── */
const dmCss = `
  /* Hero split */
  .dm-hero { padding-top: 52px; display: grid; grid-template-columns: 1fr 1fr; min-height: 100vh; }
  .dm-hero-left { padding: 80px 56px 80px 40px; display: flex; flex-direction: column; justify-content: center; border-right: 1px solid var(--rule); }
  .dm-hero-right { background: #0a1a0e; display: flex; flex-direction: column; }
  .dm-hero-title { font-family: var(--font-display); font-size: clamp(2.4rem, 5vw, 4.5rem); font-weight: 700; text-transform: uppercase; letter-spacing: 0.01em; line-height: 1.0; color: var(--ink); margin-bottom: 28px; }
  .dm-hero-title em { color: #0b7a96; font-style: normal; }
  .dm-hero-deck { font-family: var(--font-body); font-size: 1rem; color: var(--ink-3); line-height: 1.72; margin-bottom: 36px; max-width: 480px; }
  .dm-hero-actions { display: flex; gap: 12px; flex-wrap: wrap; }

  /* Meta bar */
  .dm-meta { border-top: 3px solid var(--ink); border-bottom: 1px solid var(--rule); display: grid; grid-template-columns: 1fr 1fr 1fr; }
  .dm-meta-cell { padding: 20px 40px; border-right: 1px solid var(--rule); display: flex; flex-direction: column; gap: 4px; }
  .dm-meta-cell:last-child { border-right: none; }
  .dm-meta-label { font-family: var(--font-mono); font-size: 0.6rem; letter-spacing: 0.18em; text-transform: uppercase; color: var(--ink-4); }
  .dm-meta-value { font-family: var(--font-display); font-size: 0.95rem; font-weight: 600; color: var(--ink); letter-spacing: 0.02em; }
  .dm-meta-value--teal { color: #0b7a96; }

  /* Buttons */
  .dm-btn { display: inline-flex; align-items: center; gap: 8px; padding: 12px 22px; font-family: var(--font-display); font-size: 0.75rem; font-weight: 500; letter-spacing: 0.1em; text-transform: uppercase; border: none; cursor: pointer; transition: all 0.2s; text-decoration: none; }
  .dm-btn--primary { background: #0b7a96; color: #fff; }
  .dm-btn--primary:hover { background: #085f75; }
  .dm-btn--outline { background: transparent; color: var(--ink-3); border: 1px solid var(--rule); }
  .dm-btn--outline:hover { border-color: var(--ink); color: var(--ink); }

  /* Soil profile */
  .dm-soil-art { height: 100%; display: flex; flex-direction: column; }
  .dm-soil-layer { flex: 1; position: relative; padding: 12px 24px; display: flex; align-items: center; justify-content: space-between; }
  .dm-soil-label { font-family: var(--font-mono); font-size: 0.62rem; letter-spacing: 0.1em; text-transform: uppercase; color: rgba(255,255,255,0.55); }
  .dm-soil-ksat { font-family: var(--font-display); font-size: 0.9rem; font-weight: 600; color: rgba(255,255,255,0.7); letter-spacing: 0.05em; }
  .dm-hero-caption { padding: 20px 24px; border-top: 1px solid rgba(255,255,255,0.08); }
  .dm-hero-caption-label { font-family: var(--font-mono); font-size: 0.58rem; letter-spacing: 0.16em; text-transform: uppercase; color: #0b9ab8; margin-bottom: 6px; }
  .dm-hero-caption-title { font-family: var(--font-display); font-size: 0.9rem; font-weight: 600; color: rgba(255,255,255,0.8); letter-spacing: 0.02em; }
  .dm-hero-caption-sub { font-family: var(--font-mono); font-size: 0.6rem; color: rgba(255,255,255,0.25); letter-spacing: 0.1em; margin-top: 4px; }

  /* Ksat classes bar */
  .dm-classes { border: 1px solid var(--rule); margin: 36px 0; }
  .dm-classes-head { padding: 16px 20px; border-bottom: 1px solid var(--rule); display: flex; justify-content: space-between; align-items: baseline; }
  .dm-classes-head-title { font-family: var(--font-display); font-size: 0.85rem; font-weight: 600; text-transform: uppercase; letter-spacing: 0.05em; color: var(--ink); }
  .dm-classes-head-sub { font-family: var(--font-mono); font-size: 0.6rem; color: var(--ink-4); letter-spacing: 0.1em; }
  .dm-class-row { display: grid; grid-template-columns: 140px 1fr 100px; gap: 16px; align-items: center; padding: 10px 20px; border-bottom: 1px solid var(--rule); }
  .dm-class-row:last-child { border-bottom: none; }
  .dm-class-name { font-family: var(--font-mono); font-size: 0.68rem; letter-spacing: 0.06em; color: var(--ink-3); }
  .dm-class-bar { height: 6px; border-radius: 2px; }
  .dm-class-range { font-family: var(--font-mono); font-size: 0.65rem; color: var(--ink-4); text-align: right; }

  /* Why Ksat grid */
  .dm-why { display: grid; grid-template-columns: 1fr 1fr; gap: 0; border: 1px solid var(--rule); margin: 36px 0; }
  .dm-why-item { padding: 28px 24px; border-right: 1px solid var(--rule); border-bottom: 1px solid var(--rule); }
  .dm-why-item:nth-child(2n) { border-right: none; }
  .dm-why-item:nth-last-child(-n+2) { border-bottom: none; }
  .dm-why-accent { width: 28px; height: 3px; margin-bottom: 14px; }
  .dm-why-title { font-family: var(--font-display); font-size: 0.95rem; font-weight: 600; text-transform: uppercase; letter-spacing: 0.03em; color: var(--ink); margin-bottom: 8px; }
  .dm-why-text { font-family: var(--font-body); font-size: 0.85rem; color: var(--ink-3); line-height: 1.72; }

  /* ML inputs (dark chapter) */
  .dm-inputs { display: grid; grid-template-columns: repeat(3, 1fr); gap: 1px; background: rgba(245,243,238,0.06); margin: 36px 0; border: 1px solid rgba(245,243,238,0.06); }
  .dm-input-group { padding: 24px 20px; background: var(--ink); }
  .dm-input-group-label { font-family: var(--font-mono); font-size: 0.58rem; letter-spacing: 0.18em; text-transform: uppercase; color: #0b9ab8; margin-bottom: 14px; }
  .dm-input-item { font-family: var(--font-body); font-size: 0.82rem; color: rgba(245,243,238,0.5); line-height: 1.8; display: flex; align-items: center; gap: 8px; }
  .dm-input-dot { width: 4px; height: 4px; border-radius: 50%; background: rgba(245,243,238,0.2); flex-shrink: 0; }

  /* Diff grid (dark) */
  .dm-diffs { display: grid; grid-template-columns: 1fr 1fr; gap: 0; border: 1px solid rgba(245,243,238,0.06); margin: 28px 0; }
  .dm-diff { padding: 24px 20px; border-right: 1px solid rgba(245,243,238,0.06); border-bottom: 1px solid rgba(245,243,238,0.06); }
  .dm-diff:nth-child(2n) { border-right: none; }
  .dm-diff:nth-last-child(-n+2) { border-bottom: none; }
  .dm-diff-emoji { font-size: 1.4rem; display: block; margin-bottom: 10px; line-height: 1; }
  .dm-diff-title { font-family: var(--font-display); font-size: 0.88rem; font-weight: 600; color: rgba(245,243,238,0.85); text-transform: uppercase; letter-spacing: 0.03em; margin-bottom: 6px; }
  .dm-diff-text { font-family: var(--font-body); font-size: 0.8rem; color: rgba(245,243,238,0.4); line-height: 1.7; }

  /* Dark note */
  .dm-dark-note { background: rgba(11,122,150,0.12); border-left: 3px solid #0b7a96; padding: 20px 24px; margin: 28px 0; }
  .dm-dark-note p { font-family: var(--font-body); font-size: 0.88rem; color: rgba(245,243,238,0.55); line-height: 1.7; }

  /* Deliverables grid */
  .dm-deliverables { display: grid; grid-template-columns: repeat(3, 1fr); gap: 0; border: 1px solid var(--rule); margin-top: 36px; }
  .dm-deliverable { padding: 24px 20px; border-right: 1px solid var(--rule); border-bottom: 1px solid var(--rule); }
  .dm-deliverable:nth-child(3n) { border-right: none; }
  .dm-deliverable:nth-last-child(-n+3) { border-bottom: none; }
  .dm-deliverable-emoji { font-size: 1.5rem; display: block; margin-bottom: 10px; }
  .dm-deliverable-title { font-family: var(--font-display); font-size: 0.88rem; font-weight: 600; color: var(--ink); text-transform: uppercase; letter-spacing: 0.03em; margin-bottom: 6px; }
  .dm-deliverable-text { font-family: var(--font-body); font-size: 0.8rem; color: var(--ink-3); line-height: 1.7; }

  /* CTA override for DynaMap teal */
  .dm-cta-stack { display: flex; flex-direction: column; align-items: flex-start; gap: 8px; }

  @media (max-width: 768px) {
    .dm-hero { grid-template-columns: 1fr; }
    .dm-hero-right { min-height: 340px; }
    .dm-meta { grid-template-columns: 1fr; }
    .dm-meta-cell { border-right: none; border-bottom: 1px solid var(--rule); }
    .dm-why { grid-template-columns: 1fr; }
    .dm-why-item { border-right: none; }
    .dm-inputs { grid-template-columns: 1fr; }
    .dm-diffs { grid-template-columns: 1fr; }
    .dm-diff:nth-child(2n) { border-right: none; }
    .dm-deliverables { grid-template-columns: 1fr; }
    .dm-deliverable:nth-child(3n) { border-right: none; }
    .dm-class-row { grid-template-columns: 100px 1fr 80px; }
  }
`;

const KSAT_CLASSES = [
  { label: 'Muito Rápida', range: '> 100 mm/h', color: '#0b7a96', w: '100%' },
  { label: 'Rápida', range: '36–100 mm/h', color: '#1a9db8', w: '75%' },
  { label: 'Moderada', range: '10–36 mm/h', color: '#2e8b4a', w: '55%' },
  { label: 'Lenta', range: '1–10 mm/h', color: '#c8a800', w: '35%' },
  { label: 'Muito Lenta', range: '< 1 mm/h', color: '#b03020', w: '18%' },
];

const WHY_KSAT = [
  { accent: '#0b7a96', title: 'Janelas de Plantio', text: 'Solos com Ksat baixo retêm umidade por mais tempo após chuvas — prolongando o período de tráfego proibido. Mapear essa variabilidade permite planejar a logística de campo com base em física real, não em estimativas.' },
  { accent: '#2e8b4a', title: 'Zoneamento Hídrico', text: 'A variabilidade espacial de Ksat num mesmo talhão pode superar três ordens de grandeza. Zonas com infiltração alta e zonas com drenagem limitada exigem manejos distintos de irrigação, gesso e plantio direto.' },
  { accent: '#c8a800', title: 'Eficiência de Irrigação', text: 'Sistemas dimensionados sem Ksat frequentemente aplicam lâminas incompatíveis com a absorção local. Resultado: escorrimento superficial, erosão laminar e desperdício simultâneo de água e energia.' },
  { accent: '#b03020', title: 'Diagnóstico de Compactação', text: 'A redução da Ksat ao longo das safras é indicador sensível de compactação subsuperficial. O monitoramento temporal detecta degradação estrutural antes que se torne irreversível.' },
];

const SOIL_LAYERS = [
  { label: 'Horizonte A', depth: '0–25 cm', color: '#6b4c2a', ksat: '45 mm/h', opacity: 1 },
  { label: 'Horizonte AB', depth: '25–45 cm', color: '#8a6040', ksat: '18 mm/h', opacity: 0.9 },
  { label: 'Horizonte B', depth: '45–90 cm', color: '#7a5535', ksat: '3 mm/h', opacity: 0.8 },
  { label: 'Horizonte BC', depth: '90–140 cm', color: '#a07050', ksat: '0.6 mm/h', opacity: 0.7 },
  { label: 'Horizonte C', depth: '> 140 cm', color: '#b89070', ksat: '< 0.1 mm/h', opacity: 0.6 },
];

const MODEL_INPUTS = [
  { group: 'Textura', items: ['Areia Total (%)', 'Silte (%)', 'Argila (%)'] },
  { group: 'Estrutura', items: ['Densidade do Solo (Ds)', 'Densidade de Partícula (Dp)', 'Macroporosidade'] },
  { group: 'Retenção Hídrica', items: ['θ 33 kPa (CC)', 'θ 1500 kPa (PMP)', 'θ 6 kPa (TH6)'] },
];

export default function DynaMapPage() {
  const [scrolled, setScrolled] = useState(0);

  useEffect(() => {
    const el = document.documentElement;
    const onScroll = () => setScrolled(el.scrollTop / (el.scrollHeight - el.clientHeight));
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <>
      <style>{dmCss}</style>

      <div style={{ position: 'fixed', top: 0, left: 0, right: 0, height: 2, background: '#dedad2', zIndex: 200 }}>
        <div style={{ height: '100%', width: `${scrolled * 100}%`, background: '#0b7a96', transition: 'width 0.1s linear' }} />
      </div>

      <div className="art">

        {/* ── TOP BAR ── */}
        <header className="art__back">
          <button className="art__back-btn" onClick={() => window.history.back()}>
            <FaArrowLeft size={9} /> Voltar
          </button>
          <span className="art__back-brand">DynaAgTech</span>
          <span className="art__back-issue">Análise Técnica · Dyna Map</span>
        </header>

        {/* ── HERO SPLIT ── */}
        <section className="dm-hero">
          <div className="dm-hero-left">
            <div className="art__kicker" style={{ color: '#0b7a96' }}>Dyna Map · KsatBR</div>
            <h1 className="dm-hero-title">
              O Solo Não<br />
              É Uniforme.<br />
              <em>O Manejo<br />Também Não.</em>
            </h1>
            <p className="dm-hero-deck">
              O Dyna Map gera mapas de condutividade hidráulica saturada (Ksat) a partir de atributos de solo convencionais, usando modelos de machine learning calibrados para solos brasileiros.
            </p>
            <div className="dm-hero-actions">
              <a href="/dynamap" className="dm-btn dm-btn--primary"><FaMap size={11} /> Explorar Plataforma</a>
              <button className="dm-btn dm-btn--outline" onClick={() => openWhatsApp('Gostaria de solicitar um mapeamento de condutividade hidráulica (Ksat) para meu talhão.')}>
                <FaWhatsapp size={11} /> Solicitar Mapeamento
              </button>
            </div>
          </div>

          <div className="dm-hero-right">
            <div className="dm-soil-art">
              {SOIL_LAYERS.map((layer, i) => (
                <div key={i} className="dm-soil-layer" style={{ background: `${layer.color}${Math.round(layer.opacity * 255).toString(16).padStart(2, '0')}`, borderBottom: i < SOIL_LAYERS.length - 1 ? '1px solid rgba(0,0,0,0.18)' : 'none' }}>
                  <div className="dm-soil-label">{layer.label}</div>
                  <div className="dm-soil-label" style={{ color: 'rgba(255,255,255,0.2)' }}>{layer.depth}</div>
                  {i === 0 && (
                    <svg viewBox="0 0 200 40" style={{ position: 'absolute', right: 40, width: 100, opacity: 0.3 }}>
                      {[0,1,2,3,4].map(j => (
                        <circle key={j} cx={20 + j * 40} cy={20} r={4} fill="#5FC3E4">
                          <animate attributeName="cy" values="10;30;10" dur={`${1.2 + j * 0.2}s`} repeatCount="indefinite"/>
                          <animate attributeName="opacity" values="0.8;0.2;0.8" dur={`${1.2 + j * 0.2}s`} repeatCount="indefinite"/>
                        </circle>
                      ))}
                    </svg>
                  )}
                  <div className="dm-soil-ksat">{layer.ksat}</div>
                </div>
              ))}
            </div>
            <div className="dm-hero-caption">
              <div className="dm-hero-caption-label">Perfil de Solo · Ksat por Horizonte</div>
              <div className="dm-hero-caption-title">Variabilidade vertical e horizontal determina o fluxo real de água</div>
              <div className="dm-hero-caption-sub">SoilKsat-DTCD · Random Forest · Gradient Boosting · XGBoost</div>
            </div>
          </div>
        </section>

        {/* ── META ── */}
        <div className="dm-meta">
          <div className="dm-meta-cell">
            <span className="dm-meta-label">Variável Mapeada</span>
            <span className="dm-meta-value dm-meta-value--teal">Ksat (mm/h)</span>
          </div>
          <div className="dm-meta-cell">
            <span className="dm-meta-label">Modelos de ML</span>
            <span className="dm-meta-value">RF · GBM · XGBoost</span>
          </div>
          <div className="dm-meta-cell">
            <span className="dm-meta-label">Exportação</span>
            <span className="dm-meta-value">GeoPackage · Shapefile · GeoJSON</span>
          </div>
        </div>

        {/* ── BODY ── */}
        <div className="art__body">

          {/* Cap 1 */}
          <div className="art__chapter">
            <div className="art__chapter-num"><span/>01</div>
            <div className="art__chapter-body">
              <h2 className="art__chapter-heading">Condutividade Hidráulica<br /><em>Saturada do Solo</em></h2>
              <p className="art__p">A condutividade hidráulica saturada (Ksat) é o coeficiente que governa o fluxo de água no solo quando todos os poros estão preenchidos — a condição que ocorre durante chuvas intensas, irrigação e nos dias seguintes. É medida em mm/h e varia entre frações de milímetro por hora em solos argilosos compactados e <strong>centenas de milímetros por hora</strong> em solos arenosos com alta macroporosidade.</p>
              <p className="art__p">Sua medição direta em campo — por permeâmetros de carga constante ou variável — é precisa, mas cara, demorada e sujeita à altíssima variabilidade espacial. Um talhão de 100 hectares pode conter zonas com diferença de dois a três ordens de grandeza em Ksat, tornando inviável o manejo uniforme.</p>
              <div className="art__pull">
                <p className="art__pull-text">Um talhão de 100 ha pode conter zonas com diferença de 1.000× em Ksat — invisíveis sem mapeamento.</p>
                <span className="art__pull-source">Fundamento Técnico · Física do Solo</span>
              </div>
              <p className="art__p">O Dyna Map resolve esse gargalo com um método de estimativa por pedotransferência (PTF) baseada em machine learning — capaz de gerar mapas de alta resolução a partir de análises de solo que o produtor <strong>já realiza por outras razões</strong>.</p>
              <div className="dm-classes">
                <div className="dm-classes-head">
                  <span className="dm-classes-head-title">Classes de Condutividade</span>
                  <span className="dm-classes-head-sub">Classificação por faixa de Ksat</span>
                </div>
                {KSAT_CLASSES.map((cls, i) => (
                  <div className="dm-class-row" key={i}>
                    <div className="dm-class-name">{cls.label}</div>
                    <div style={{ flex: 1 }}><div className="dm-class-bar" style={{ width: cls.w, background: cls.color, maxWidth: 180 }}/></div>
                    <div className="dm-class-range">{cls.range}</div>
                  </div>
                ))}
              </div>
            </div>
          </div>

          {/* Cap 2 */}
          <div className="art__chapter">
            <div className="art__chapter-num"><span/>02</div>
            <div className="art__chapter-body">
              <h2 className="art__chapter-heading">Quatro Decisões de Manejo<br /><em>que Dependem da Ksat</em></h2>
              <p className="art__p">A Ksat não é uma curiosidade pedológica. Ela determina diretamente janelas de operação, eficiência de irrigação, dinâmica de compactação e retorno de insumos. Ignorá-la é gerir o risco hídrico às cegas.</p>
              <div className="dm-why">
                {WHY_KSAT.map((item, i) => (
                  <div className="dm-why-item" key={i}>
                    <div className="dm-why-accent" style={{ background: item.accent }}/>
                    <div className="dm-why-title">{item.title}</div>
                    <div className="dm-why-text">{item.text}</div>
                  </div>
                ))}
              </div>
              <div className="art__data">
                <div className="art__datum">
                  <div className="art__datum-label">Variabilidade Espacial</div>
                  <div className="art__datum-value" style={{ color: '#0b7a96' }}>10³×</div>
                  <div className="art__datum-sub">amplitude possível de Ksat num único talhão</div>
                </div>
                <div className="art__datum">
                  <div className="art__datum-label">Custo da Medição Direta</div>
                  <div className="art__datum-value" style={{ color: '#b03020' }}>↑↑↑</div>
                  <div className="art__datum-sub">permeâmetro de campo: laborioso, caro, pontual</div>
                </div>
                <div className="art__datum">
                  <div className="art__datum-label">Método PTF via ML</div>
                  <div className="art__datum-value" style={{ color: '#2e8b4a' }}>↓↓↓</div>
                  <div className="art__datum-sub">usa análises de solo que você já tem</div>
                </div>
              </div>
            </div>
          </div>

        </div>

        {/* Cap 3 — dark */}
        <div className="art__body">
          <div className="art__chapter art__chapter--dark" style={{ '--teal': '#0b7a96' }}>
            <div className="art__dark-head">
              <span className="art__dark-head-kicker">03 · Metodologia de Predição</span>
              <div className="art__dark-head-line"/>
            </div>
            <h2 className="art__chapter-heading" style={{ color: 'var(--paper)' }}>Machine Learning<br /><em style={{ color: '#0b9ab8' }}>Calibrado para Ksat</em></h2>
            <p className="art__p">O modelo SoilKsat-DTCD foi desenvolvido especificamente para predição de Ksat em solos brasileiros, com arquitetura e hiperparâmetros ajustados para a distribuição log-normal característica da variável. A variável alvo é transformada como ln(Ksat+1) antes do treinamento — adequada à distribuição e essencial para evitar viés nos extremos da curva.</p>
            <div className="dm-inputs">
              {MODEL_INPUTS.map((g, i) => (
                <div className="dm-input-group" key={i}>
                  <div className="dm-input-group-label">{g.group}</div>
                  {g.items.map((item, j) => (
                    <div className="dm-input-item" key={j}><div className="dm-input-dot"/>{item}</div>
                  ))}
                </div>
              ))}
            </div>
            <div className="dm-diffs">
              {[
                { emoji: '🔬', title: 'Escala Logarítmica', text: 'Variável alvo transformada como ln(Ksat+1) — adequada à distribuição log-normal e essencial para evitar viés nos extremos da curva de predição.' },
                { emoji: '🔄', title: 'Validação K-Fold', text: 'Performance avaliada por R², RMSE, NSE e PBIAS com K-Fold repetido (5×3). Métricas reportadas para conjunto de teste holdout separado do treinamento.' },
                { emoji: '📍', title: 'Features Derivadas', text: 'Porosidade e macroporosidade derivadas automaticamente de Ds, Dp e TH6 quando disponíveis — maximizando a informação de análises convencionais de solo.' },
                { emoji: '🌍', title: 'Solos Brasileiros', text: 'Treinado com dataset de solos do Brasil — Latossolos, Argissolos, Neossolos. Desempenho superior a PTFs genéricas calibradas para outros contextos pedológicos.' },
              ].map((d, i) => (
                <div className="dm-diff" key={i}>
                  <span className="dm-diff-emoji">{d.emoji}</span>
                  <div className="dm-diff-title">{d.title}</div>
                  <div className="dm-diff-text">{d.text}</div>
                </div>
              ))}
            </div>
            <div className="dm-dark-note">
              <p>A qualidade do mapa gerado é proporcional à densidade da malha amostral. O serviço de consultoria inclui orientação sobre o desenho amostral mínimo para atingir a resolução espacial necessária para cada objetivo de manejo.</p>
            </div>
          </div>
        </div>

        {/* Cap 4 */}
        <div className="art__body">
          <div className="art__chapter">
            <div className="art__chapter-num"><span/>04</div>
            <div className="art__chapter-body">
              <h2 className="art__chapter-heading">Da Coleta ao<br /><em>Mapa Georreferenciado</em></h2>
              <p className="art__p">O processo integra coleta de campo, predição por machine learning e interpolação espacial para entregar um produto diretamente utilizável em QGIS e plataformas de agricultura de precisão.</p>
              <div className="art__steps">
                {[
                  { n: '1', title: 'Coleta e Caracterização do Solo', text: 'Definição da malha amostral e coleta por horizonte. A análise laboratorial fornece os atributos físicos, texturais e de retenção hídrica que alimentam o modelo — os mesmos de análises convencionais de solo.' },
                  { n: '2', title: 'Predição com Machine Learning', text: 'Atributos inseridos no modelo SoilKsat, treinado com dados de solos brasileiros e validado por K-Fold. O modelo estima Ksat em escala logarítmica e reconverte para mm/h.' },
                  { n: '3', title: 'Interpolação Espacial', text: 'Valores preditos em cada ponto são interpolados sobre uma grade configurável (50–500 pontos) por método linear, cúbico ou vizinho próximo, recortada ao limite do talhão via shapefile.' },
                  { n: '4', title: 'Mapa de Confiabilidade', text: 'Junto ao mapa de Ksat, é gerado um mapa de confiabilidade da interpolação — baseado na distância ao ponto amostral mais próximo. Regiões extrapoladas são sinalizadas claramente.' },
                  { n: '5', title: 'Entrega e Integração com QGIS', text: 'Arquivo vetorial georreferenciado (GeoPackage ou Shapefile) com atributos ksat_mmh, ksat_log10 e classe de condutividade — pronto para workflows de agricultura de precisão.' },
                ].map((s) => (
                  <div className="art__step" key={s.n}><div className="art__step-n">{s.n}</div><div><h4>{s.title}</h4><p>{s.text}</p></div></div>
                ))}
              </div>
              <div className="art__note">
                <div className="art__note-label">Compatibilidade</div>
                <p>Todos os arquivos de entrega são compatíveis com QGIS (abrir direto), Google Earth Engine (import como asset) e plataformas de AP como Farmtell, John Deere Operations Center e CNH AFS.</p>
              </div>
              <div className="dm-deliverables">
                {[
                  { emoji: '🗺️', title: 'Mapa de Ksat (mm/h)', text: 'Mapa interpolado sobre o talhão com escala de cores e legenda de classes de condutividade.' },
                  { emoji: '⚠️', title: 'Mapa de Confiabilidade', text: 'Distância ao vizinho mais próximo — indica regiões interpoladas com alta confiança versus extrapolação.' },
                  { emoji: '📦', title: 'GeoPackage / Shapefile', text: 'Vetorial georreferenciado pronto para QGIS com ksat_mmh, ksat_log10 e classe por polígono.' },
                  { emoji: '📊', title: 'Métricas do Modelo', text: 'R², RMSE, NSE, PBIAS, Fator 2 e Fator 10 — documentação completa de desempenho.' },
                  { emoji: '📄', title: 'Tabela de Predições', text: 'Planilha com todos os pontos, atributos de entrada, Ksat predito e classe — integrável com ERPs.' },
                  { emoji: '🔄', title: 'Atualização por Safra', text: 'Modelo retreinado com novas amostras para monitorar evolução temporal e detectar compactação.' },
                ].map((d, i) => (
                  <div className="dm-deliverable" key={i}>
                    <span className="dm-deliverable-emoji">{d.emoji}</span>
                    <div className="dm-deliverable-title">{d.title}</div>
                    <div className="dm-deliverable-text">{d.text}</div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>

        {/* ── CTA ── */}
        <div className="art__cta">
          <h2 className="art__cta-heading" style={{ '--lime-dark': '#0b7a96' }}>
            Manejo hídrico<br />começa pela<br /><em>física do solo.</em>
          </h2>
          <div className="art__cta-right">
            <p className="art__cta-desc">Um talhão manejado de forma homogênea sobre uma Ksat heterogênea desperdiça insumos, água e janelas de trabalho. O mapeamento transforma essa variabilidade em zonas de manejo acionáveis.</p>
            <div className="dm-cta-stack">
              <button className="dm-btn dm-btn--primary" onClick={() => openWhatsApp('Gostaria de solicitar um mapeamento de condutividade hidráulica Ksat para o meu talhão.')}>
                <FaWhatsapp size={11} /> Solicitar Mapeamento de Ksat
              </button>
              <a href="/dynamap" className="dm-btn dm-btn--outline"><FaMap size={11} /> Explorar Plataforma</a>
              <a href="/" className="dm-btn dm-btn--outline"><FaArrowLeft size={10} /> Ver Todas as Soluções</a>
            </div>
          </div>
        </div>

        <footer className="art__footer">
          <span className="art__footer-note">© 2025 DynaAgTech · AgTech de Otimização Agrícola</span>
          <span className="art__footer-note">dynastartup.vercel.app</span>
        </footer>

      </div>
    </>
  );
}